import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Conversion Fields */
import ConversionFieldChoice from '../fields/ConversionFieldChoice';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionComponentLeaseCalculator({ component, path, id, ...passProps }) {
    return (
        <>
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
                renderField={(field, props) => {
                    if (field.type === 'choice-radio') {
                        return (
                            <div className={props?.colClassName}>
                                <div className="row gutters-1 gutters-lg-4 align-items-center">
                                    <div className="col-12 col-xl-3">
                                        <p className="">
                                            <b>{field?.label?.split(' ')?.[0]}</b>
                                            <br />
                                            <span className="text--sm text-muted--40">{field?.label?.split(' ')?.slice(1)?.join(' ')}</span>
                                        </p>
                                    </div>
                                    <ConversionFieldChoice
                                        {...props}
                                        field={{
                                            ...field,
                                            label: null,
                                        }}
                                        colClassName="col-12 col-lg-9"
                                        formGroupClassName="form-group--flow-choice-grid"
                                        customControlClassName="custom-control--expanded custom-control--grow"
                                        inputType="radio"
                                    />
                                </div>
                            </div>

                        );
                    }
                }}
            />
            <div className="col-12">
                <p className="mb-1">{trans('app.flow.lease.calculator.price_per_month')}</p>
                <p className="h6 font-weight-bold">{`€ ${component.metadata.price_per_month.toLocaleString('nl-NL')}`}</p>
            </div>
        </>
    );
}
